import { z } from "zod";
import route from "./route";

export const SUBSCRIPTION_INVOICE_ROUTES = {
  subscriptionInvoices: {
    markAsCancelled: route.fromTemplate("/subscription-invoices/:id/cancel", {
      params: z.object({ id: z.string() }),
    }),
    markAsPaid: route.fromTemplate("/subscription-invoices/:id/mark-as-paid", {
      params: z.object({ id: z.string() }),
    }),
    markAsUnpaid: route.fromTemplate(
      "/subscription-invoices/:id/mark-as-unpaid",
      {
        params: z.object({ id: z.string() }),
      },
    ),
    single: route.fromTemplate("/subscription-invoices/:id", {
      params: z.object({ id: z.string() }),
    }),
    markAsReadyToSend: route.fromTemplate(
      "/subscription-invoices/:id/mark-as-ready-to-send",
      {
        params: z.object({ id: z.string() }),
      },
    ),
    send: route.fromTemplate("/subscription-invoices/:id/send", {
      params: z.object({ id: z.string() }),
    }),
    pdf: route.fromTemplate("/subscription-invoices/:id.pdf", {
      params: z.object({ id: z.string() }),
    }),
    processingPayment: route.fromTemplate(
      "/subscription-invoices/:id/processing-payment",
      {
        params: z.object({ id: z.string() }),
        query: z.object({ session_id: z.string() }),
      },
    ),
    charge: route.fromTemplate("/subscription-invoices/:id/charge", {
      params: z.object({ id: z.string() }),
    }),
  },
};
